<template>
  <div>
    <form id="orgaoForm" @submit.prevent="submit" class="ajax_off">
      <div class="form-group">
        <input type="text" class="form-control" v-model="nome" required />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nome: null,
    };
  },
  methods: {
    async submit() {
      const result = await this.$api.post("orgao", { nome: this.nome });

      if (result.data.orgao_id) {
        this.$emit("created", result.data.orgao_id);
        this.$bvModal.hide("orgao");
      }
    },
  },
  // watch: {
  //   form: {
  //     handler: function (v) {
  //       return this.$store.commit("modal/formData", {
  //         name: "orgao",
  //         data: this.form,
  //       });
  //     },
  //     deep: true,
  //   },
  // },
};
</script>